var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"panoramica"},[_c(_vm.infoTemplateComponent,{tag:"component",attrs:{"info":_vm.options.info[0],"isOnComputer":true}})],1),_c('qrBox')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }